import { render, staticRenderFns } from "./ConstructorButton.vue?vue&type=template&id=0ea8bf84"
import script from "./ConstructorButton.vue?vue&type=script&lang=js"
export * from "./ConstructorButton.vue?vue&type=script&lang=js"
import style0 from "./ConstructorButton.vue?vue&type=style&index=0&id=0ea8bf84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports